import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles, Theme } from '@material-ui/core/styles';

interface RadioProps {
  fields: any[];
  name: string;
  value: string;
  onSelect: (value: string) => any;
}

export default function RadioGroupComponent(props: RadioProps) {
  const { fields, name, value, onSelect } = props;
  const styles = useStyles();
  const handleChange = (childIdx) => (event) => {
    onSelect(event.target.value);
  };
  return (
    <FormControl component="fieldset" className={styles.formContainer}>
      <RadioGroup name={name} value={value}>
        {fields.map((child, childIdx) => (
          <FormControlLabel
            key={childIdx}
            value={child.value}
            onChange={handleChange(childIdx)}
            label={child.label}
            labelPlacement="start"
            classes={{label: styles.formControlLabel}}
            className={styles.formLabel}
            control={<Radio color="primary" className={`p-0 ${styles.tickSize}`} />}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  formContainer: {
    width: '100%'
  },
  formControlLabel: {
    fontWeight: theme.palette.type === 'dark' ? 500 : 600,
    color:`${theme.palette.text.primary} !important`,
    fontSize: '15px',
  },
  formLabel: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 0,
    
  },
  tickSize: {
    // transform: "scale(0.6)",
},
}));
